import React, { useCallback, useEffect, useState } from 'react';
import "../../assets/styles/Search.css";
import Swal from "sweetalert2";
import iconSearch from "../../icons/icon-search.png";
import imgBottom from "../../imgs/img-bottom-cskh.png";
import imgBottomMb from "../../imgs/img-bottom-cskh-mb.png";

import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import { config } from "../../config.js";
import { apiCheckAccount, apiGetSetting, getCaptchaTokenClient } from "../../services/api.service.js";

function SearchUser() {
  const [userName, setUserName] = useState("");
  const [domains, setDomains] = useState("");
  const [webSetting, setWebSetting] = useState("");
  const [isChecking, setIsChecking] = useState(false);
  const lastBank = new URLSearchParams(window.location.search).get("last_bank")?.trim() || "";
  const navigate = useNavigate();

  const checkUser = useCallback(async (account, settings, bank) => {
      if (!account) {
        return Swal.fire({ icon: "error", text: "Vui lòng nhập tên tài khoản." });
      } else {
        setIsChecking(true);
        const handleResult = (result) => {
          if (result?.code !== 200) return;
          Swal.close();
          const data = result.data;
          const state = { userName: account, data, webSetting: settings, lastBank: bank };
          // vào từ link có last_bank: thay trang hiện tại để lịch sử tab chỉ có 1 trang, nút back mới đóng được tab
          const replace = !!bank;
          if (data?.have_btn_confirm_account === true) {
            navigate("/profile", { state: { ...state, sendType: "files" }, replace });
          } else {
            navigate("/type-confirm", { state, replace });
          }
        };
        Swal.fire({
          titleText: "Đang kiểm tra ...",
          color: "#ffffff",
          allowOutsideClick: false,
          background: `linear-gradient(#d73316cc,#ff9800cf)`,
          width: 320,
          didOpen: () => {
            Swal.showLoading();
          },
        });
        try {
          if (bank) {
            handleResult(await apiCheckAccount(account, undefined, undefined, bank));
            return;
          }
          let loadCaptcha = await getCaptchaTokenClient();
          document.cookie = `token=${loadCaptcha.token}; max-age=180; path=/`;
          let tokenCaptcha = loadCaptcha.token;
          Swal.fire({
            title: "Mã Xác Thực",
            showConfirmButton: false,
            allowOutsideClick: false,
            html: `
            <div class="input-form-captcha-wrapper">
              <div class="thumb-captcha">
                <img id="captcha-image" class="image-captcha notranslate" src="" alt="Captcha Image">
              </div>
              <div class="input-form-captcha">
                <input class="notranslate" translate="no" type="text" placeholder="Nhập mã captcha" id="captcha-input" style="font-size:16px; text-transform: uppercase;" oninput="this.value = this.value.toUpperCase()">
                </input>
              </div>
            </div>
            <button id="verify-captcha" class="swal2-confirm swal2-styled">Xác Thực</button>
          `,
          });

          document.getElementById("captcha-image").src = loadCaptcha.captchaUrl;
          document
            .getElementById("captcha-image")
            .addEventListener("click", async () => {
              let newCaptcha = await getCaptchaTokenClient();
              tokenCaptcha = newCaptcha.token;
              document.cookie = `token=${newCaptcha.token}; max-age=180; path=/`;
              document.getElementById("captcha-image").src = newCaptcha.captchaUrl;
            });
          document
            .getElementById("verify-captcha")
            .addEventListener("click", async () => {
            const captchaInputValue = document.getElementById("captcha-input").value;
            const result = await apiCheckAccount(account, captchaInputValue, tokenCaptcha);
            handleResult(result);
          });
        } catch (error) {
          console.error("Error fetching code:", error);
          Swal.fire({ icon: "error", text: "Thao tác lỗi, vui lòng thử lại sau." });
        } finally {
          setIsChecking(false);
        }
      }
  }, [navigate]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const account = params.get("account")?.trim().toLowerCase() || "";
    const bank = params.get("last_bank")?.trim() || "";
    setUserName(account);
    const fetchData = async () => {
      try {
        const result = await apiGetSetting();
        if (result?.status_code === 200 && result.data) {
          setWebSetting(result.data);
          if (account) await checkUser(account, result.data, bank);
        } else {
          Swal.fire({ icon: "error", text: "Không thể tải cấu hình, vui lòng tải lại trang để thử lại." });
        }
      } catch (error) {
        Swal.fire({ icon: "error", text: "Lỗi kết nối, vui lòng liên hệ CSKH 24/7 để được hỗ trợ." });
      }
    };
    fetchData();
  }, [checkUser]);

  return (
    <div className="container">
      <div className="app">
        <Header isPageSearch={true} data={{webSetting}}/>
        <div className="content content-mb">
          <div className="search-user">
            <span>VUI LÒNG XÁC NHẬN TÀI KHOẢN CỦA BẠN</span>
            <div className="input-search">
              {/* <img className="icon-search" alt="icon-search" src={iconSearch} /> */}
              <input className="input-account"
                value={userName}
                onChange={(e) => setUserName(e.target.value.toLowerCase().trim())}
                type="text"
                placeholder="Nhập tên tài khoản"
              />
              <button className="btn-search-account" disabled={!webSetting || isChecking} onClick={() => checkUser(userName, webSetting, lastBank)}>KIỂM TRA</button>
            </div>
            <div className="out-img-bottom-mb">
              <img className="img-bottom-mb" alt="bottom" src={imgBottom} />
            </div>
            <div className="description">
              {/* <div className="out-title-description">
                <span className="title-description">LINK CHÍNH THỨC: {webSetting?.link_home?.replace("https://", "") ?? "F168M.COM"}</span>
              </div> */}
              {webSetting && webSetting.login_info_notice ? (
                <div dangerouslySetInnerHTML={{ __html: webSetting.login_info_notice }} />
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <div>
        <div className="content content-pc">
          <div className="search-user">
            <span>VUI LÒNG XÁC NHẬN TÀI KHOẢN CỦA BẠN</span>
            <div className="input-search">
              {/* <img className="icon-search" alt="icon-search" src={iconSearch} /> */}
              <input className="input-account"
                value={userName}
                onChange={(e) => setUserName(e.target.value.toLowerCase().trim())}
                type="text"
                placeholder="Nhập tên tài khoản"
              />
              <button className="btn-search-account" disabled={!webSetting || isChecking} onClick={() => checkUser(userName, webSetting, lastBank)}>KIỂM TRA</button>
            </div>
            <div className="content-detail-pc">
              <div>
                <img className="img-bottom" alt="bottom" src={imgBottom} />
              </div>
              <div className="description">
                {webSetting && webSetting.login_info_notice ? (
                  <div dangerouslySetInnerHTML={{ __html: webSetting.login_info_notice }} />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SearchUser;
